import { Component, Input, OnInit } from '@angular/core';
import { SiteFormResponse } from 'app/_models/site-forms/site-form-response.model';
import { environment } from 'environments/environment';

@Component({
  selector: 'site-form-response-preview-pane',
  templateUrl: './site-form-response-preview-pane.component.html'
})
export class SiteFormResponsePreviewPaneComponent implements OnInit {

  @Input() siteFormResponse: SiteFormResponse;
  @Input() logoUrl: string;
  @Input() includePhotos: boolean;
  public environment: any = environment;

  constructor() { }

  ngOnInit() {
  }

}
